import * as z from "zod";

/**
 * A scraped shop directory, imported as unclaimed stores. One source row becomes
 * one `IMPORTED` store with exactly one location.
 *
 * Preview and commit run the same normalizer, so what a preview reports is the
 * plan itself and not an approximation of it.
 */

export const ShopImportRow = z.object({
  sourceRef: z.string().nullable(),
  name: z.string().nullable(),
  /** `skip-claimed`: an owner has taken this shop over, and their edits win over a refreshed scrape. */
  action: z.enum(["create", "update", "skip-claimed", "reject"]),
  city: z.string().nullable(),
  country: z.string().nullable(),
  /** Non-fatal: the row still imports, with that field left null. */
  warnings: z.array(z.string()),
  /** Fatal for this row — it will not be imported. */
  errors: z.array(z.string()),
});
export type ShopImportRow = z.output<typeof ShopImportRow>;

export const ShopImportPreview = z.object({
  totalRows: z.number(),
  toCreate: z.number(),
  toUpdate: z.number(),
  skippedClaimed: z.number(),
  rejected: z.number(),
  withWarnings: z.number(),
  rows: z.array(ShopImportRow),
});
export type ShopImportPreview = z.output<typeof ShopImportPreview>;

export const ShopImportResult = z.object({
  created: z.number(),
  updated: z.number(),
  skippedClaimed: z.number(),
  rejected: z.number(),
  /** Rows that passed validation but failed to write. */
  failed: z.number(),
  /** First 20 write failures. */
  errors: z.array(z.string()),
});
export type ShopImportResult = z.output<typeof ShopImportResult>;
